import { getDomain } from '../../utils/config';

const SPICE_PATH = '/design/tools-software/spice-live-model/';
const EPS_PATH = '/design/tools-software/elite-pairing-studio/choose';

/**
 * Returns environment type and UAT instance number parsed from the hostname.
 * Distinguishes localhost from UAT so each gets its own base URL.
 */
function getEnvironment() {
	const hostname = window.location.hostname;
	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		return { type: 'LOCAL', uatNumber: null };
	}
	const uatMatch = hostname.match(/uat(\d+)/i);
	if (uatMatch) {
		return { type: 'UAT', uatNumber: uatMatch[1] };
	}
	return { type: 'PROD', uatNumber: null };
}

/**
 * Builds the SPICE Live Model URL for a given part number.
 * – LOCAL  → http://localhost:2000/…/spice-live-model/<partNumber>
 * – UAT    → https://livedatasheet-uat<N>.<domain>/…/spice-live-model/<partNumber>
 * – PROD   → https://www.<domain>/…/spice-live-model/<partNumber>
 */
export function buildSpiceLiveModelUrl(partNumber) {
	const { type, uatNumber } = getEnvironment();
	const domain = getDomain();

	if (type === 'LOCAL') {
		return `http://localhost:2000${SPICE_PATH}${partNumber}`;
	}
	if (type === 'UAT') {
		return `https://livedatasheet-uat${uatNumber}.${domain}${SPICE_PATH}${partNumber}`;
	}
	return `https://www.${domain}${SPICE_PATH}${partNumber}`;
}

/**
 * Builds the Elite Pairing Studio URL.
 * – Gate Driver rows use a generic link (no OPN appended).
 * – MOSFET rows append the OPN at the end.
 * – LOCAL  → http://localhost:2000/design/tools-software/elite-pairing-studio/choose[/<partNumber>]
 * – UAT    → https://gate-driver-kit-uat<N>.<domain>/design/tools-software/elite-pairing-studio/choose[/<partNumber>]
 * – PROD   → https://www.<domain>/design/tools-software/elite-pairing-studio/choose[/<partNumber>]
 */
export function buildElitePairingStudioUrl(partNumber, isGateDriver) {
	const { type, uatNumber } = getEnvironment();
	const domain = getDomain();
	const opnSuffix = isGateDriver ? '' : `/${partNumber}`;

	if (type === 'LOCAL') {
		return `http://localhost:2000${EPS_PATH}${opnSuffix}`;
	}
	if (type === 'UAT') {
		return `https://gate-driver-kit-uat${uatNumber}.${domain}${EPS_PATH}${opnSuffix}`;
	}
	return `https://www.${domain}${EPS_PATH}${opnSuffix}`;
}
